require('es6-promise');
require('isomorphic-fetch');
const createAction = require('redux-actions').createAction;
const config = require('../../config');
const setNearShopList = createAction('SET_NEAR_SHOP_LIST', nearShopList => nearShopList);
const setAllShopList = (exports.setAllShopList = createAction('SET_ALL_SHOP_LIST', allShopList => allShopList));
const setErrorMsg = (exports.setErrorMsg = createAction('SET_ERROR_MSG', error => error));
const setLoadMsg = (exports.setLoadMsg = createAction('SET_LOAD_MSG', loadinfo => loadinfo));
const setYCSShop = createAction('SET_YCS_SHOP', yunChengSchoolFlag => yunChengSchoolFlag);
exports.clearAllShopList = createAction('CLEAR_ALL_SHOP_LIST');
exports.clearNearShopList = createAction('CLEAR_NEAR_SHOP_LIST');
const setCityList = createAction('SET_CITY_LIST', citylist => citylist);
import { getRunEnv, getUrlParam } from '../../helper/common-helper';
import fetchHelper from '../../helper/fetch-helper';
// eslint-disable-next-line
import { getTransformedLocation } from '../../helper/map-TARGET_AREA';
import { isOversea, MAP_TYPE } from '../../helper/const';

import { formatMessage } from '../../intl/helper';
import actionText3 from '../../intl/messages/action/part3';
import actionText1 from '../../intl/messages/action/part1';
import actionText4 from '../../intl/messages/action/part4';

const brandId = parseInt(getUrlParam('brandId'), 10) || 0; // todo refactoring
const shopId = getUrlParam('shopId');
const uniqueId = getUrlParam('uniqueId');

exports.getCurLocation = callBack => (dispatch, getState) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText3.actionLocating) }));
  getTransformedLocation()
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      callBack(
        {
          isGetLoc: true,
          uniqueId: 'TS',
          brandId,
          shopId,
          ...result,
        },
        { address: result.address, addressOk: true },
      );
    })
    .catch(error => {
      dispatch(setErrorMsg(error.message));
      dispatch(setLoadMsg({ status: false, word: '' }));
      callBack({}, { address: error.message, addressOk: false });
    });
};

exports.getNearShopList = (curPosition = {}, object = {}, callBack) => (dispatch, getState) => {
  let params = {
    brandId,
    shopId,
    uniqueId,
    pageNum: object.pageNum,
    // keyWord: object.keyWord ? object.keyWord.replace(/\s/g, '') : '',
    keyWord: object.keyWord ? object.keyWord.trim() : '',
    runEnv: getRunEnv(),
  };

  if (!curPosition.isGetLoc && window.ycsFlag === false) {
    dispatch(setErrorMsg(formatMessage(actionText3.actioncannotGetNearShop)));
    dispatch(setLoadMsg({ status: false, word: formatMessage(actionText3.actioncannotGetNearShop) }));
    return;
  }

  if (curPosition.isGetLoc) {
    params = {
      ...params,
      isGetLoc: curPosition.isGetLoc,
      longitude: curPosition.longitude,
      latitude: curPosition.latitude,
    };
  }

  if (isOversea) {
    params.mapType = MAP_TYPE.G_MAP;
  }

  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText1.actionLoading) }));

  fetchHelper
    .get(config.shopListTSNearAPI, params)
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (result) {
        if (callBack) {
          callBack(result);
        }
        dispatch(setNearShopList(result));
      }
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

exports.getAllShopList = (chosenPosition = {}, curPosition = {}, object = {}, callback) => (dispatch, getState) => {
  if (!chosenPosition.isGetLoc) {
    // 定位超时
    dispatch(setErrorMsg(formatMessage(actionText3.actioncityLocateFailed)));
    dispatch(setLoadMsg({ status: false, word: '' }));
    return;
  }

  const params = {
    shopId,
    brandId,
    uniqueId,
    pageNum: object.pageNum,
    // keyWord: object.keyWord ? object.keyWord.replace(/\s/g, '') : '',
    keyWord: object.keyWord ? object.keyWord.trim() : '',
    cityId: chosenPosition.cityId,
    latitude: curPosition.latitude,
    longitude: curPosition.longitude,
    isGetLoc: curPosition.isGetLoc,
    runEnv: getRunEnv(),
  };

  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText1.actionLoading) }));

  fetchHelper
    .get(config.shopListTSAPI, params)
    .then(result => {
      dispatch(
        setLoadMsg({
          status: false,
          word: '',
        }),
      );
      if (result) {
        dispatch(setAllShopList(result));
        if (callback) {
          callback(result);
        }
        if (result.length === 0) {
          dispatch(setErrorMsg(formatMessage(actionText4.actionnomoreShopInfo)));
        }
      }
      dispatch(setLoadMsg({ status: false, word: '' }));
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

// YCS
exports.getYCSAllShopList = (object, callback) => (dispatch, getState) => {
  // object { pageNum, keyWord, dinningRoomIndex}
  const { pageNum, keyWord, dinningRoomIndex } = object || {};
  const currentDinningRoom = parseInt(dinningRoomIndex, 10);
  const runEnv = getRunEnv();
  const params =
    // `?shopId=${shopId}&brandId=${brandId}&pageNum=${pageNum}&keyWord=${keyWord.replace(/\s/g, '')}&uniqueId=${uniqueId}` +
    `?shopId=${shopId}&brandId=${brandId}&pageNum=${pageNum}&keyWord=${keyWord.trim()}&uniqueId=${uniqueId}` +
    `&dinningRoomIndex=${currentDinningRoom}&runEnv=${runEnv}`;

  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText1.actionLoading) }));

  fetchHelper
    .get(`${config.shopListTSAPI}${params}`)
    .then(result => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (result) {
        dispatch(setAllShopList(result)); // 拿到了数据
        if (callback) {
          callback(result);
        }
        if (result.length === 0) {
          dispatch(setErrorMsg(formatMessage(actionText3.actionnomoreStore)));
        }
      }
      dispatch(setLoadMsg({ status: false, word: '' }));
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
    });
};

// 获取排队状态..
exports.getQueueInfo = (ShopId, callback) => (dispatch, getState) =>
  fetchHelper.get(`${config.isQueueURL}?shopId=${ShopId}`, null, { enableDefaultResponseResolve: false }).catch(error => {
    console.log(error);
  });

exports.clearErrorMsg = () => (dispatch, getState) => dispatch(setErrorMsg(''));

exports.getCityList = resolve => (dispatch, getState) => {
  const runEnv = getRunEnv();
  fetchHelper
    .get(`${config.cityListAPI}?brandId=${brandId}&shopId=${shopId}&uniqueId=${uniqueId}&runEnv=${runEnv}`)
    .then(result => {
      if (result) {
        // YSC 标志
        dispatch(setYCSShop(result.yunChengSchoolFlag));
        window.ycsFlag = result.yunChengSchoolFlag;
        dispatch(setCityList(result));
      }
      resolve();
    })
    .catch((err = {}) => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(err.msg ? err.msg : formatMessage(actionText4.actioninternetAnomaly)));
      resolve();
    });
};



// WEBPACK FOOTER //
// ./src/action/shop-list/shop-list-ts.js